import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { PREVIEW_MODE } from './preview/preview-mode';
import './styles.css';

if (PREVIEW_MODE) {
  // Nur im lokalen Vorschaumodus: sichtbarer Hinweis auf die Beispieldaten.
  void import('./preview/preview-banner').then((module) => module.mountPreviewBanner());
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Wurzelelement nicht gefunden.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
